/**
 * Pré-seleciona o segmento no formulário de contato quando a pessoa clica em
 * "Falar sobre <segmento>". Funciona entre seções da mesma página (evento) e
 * entre páginas (sessionStorage).
 */
import type { SegmentId } from "@/data/segments";

export const CONTACT_SEGMENT_EVENT = "alertai:contact-segment";
const KEY = "alertai:contact-segment";

export function requestContactSegment(id: SegmentId) {
  try {
    sessionStorage.setItem(KEY, id);
  } catch {
    /* modo privado / storage bloqueado: apenas o evento é usado */
  }
  window.dispatchEvent(new CustomEvent<SegmentId>(CONTACT_SEGMENT_EVENT, { detail: id }));
}

export function readContactSegment(): SegmentId | null {
  try {
    const v = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return v as SegmentId | null;
  } catch {
    return null;
  }
}
